import React from "react";
import { useTranslation } from "react-i18next";
import { Card, Col } from "react-bootstrap";
import CurrencyValue from "../CurrencyValue";

const IncomeDOC = ({ size, data }) => {
  const { t } = useTranslation();
  return (
    <Col md={size} className="mb-3">
      <Card bg="dark1" className="h-100">
        <Card.Header className="text-light text-uppercase">
          {t("incomeNdoc")}
        </Card.Header>
        <Card.Body className="text-light">
          <ul className="list-unstyled">
            <li className="d-flex justify-content-between mb-3">
              <span>{t("direct")}</span>
              <CurrencyValue amount={data?.data?.doc?.directDoc ||
                data?.data?.directCommission ||
                data?.data?.dcCommission ||
                data?.data?.directCommission}
              />
            </li>
            <li className="d-flex justify-content-between mb-3">
              <span>{t("first2Levels")}</span>
              <CurrencyValue amount={data?.data?.doc?.firstTwoLevelDoc ||
                data?.data?.dcOverCommission ||
                data?.data?.firstTwoLevelCommission} />
            </li>
            <li className="d-flex justify-content-between mb-3">
              <span>{t("poolBonus")}</span>
              <CurrencyValue amount={data?.data?.poolBonus} />
            </li>
            <li className="d-flex justify-content-between mb-3">
              <span>{t("teamManager")}</span>
              <CurrencyValue amount={data?.data?.doc?.teamManagerDoc ||
                data?.data?.teamManagerCommission} />
            </li>
            <li className="d-flex justify-content-between mb-3">
              <span>{t("teamManagerPool")}</span>
              <CurrencyValue amount={data?.data?.teamManagerPool} />
            </li>
          </ul>
        </Card.Body>
      </Card>
    </Col>
  );
};

export default IncomeDOC;
